// extracted by css-extract-rspack-plugin
export default {"page":"d_ayl","header":"phZah","content":"Pzv4i","logo_link":"LH1Ul","logoLink":"LH1Ul","markdown":"H8Pag"};